/**
 * System Constants
 */
const constants = {
  SHARED_MESSAGE_AUTO_CLOSE_DELAY: 5000,
  DOWNLOAD_INVENTORY_PROMPT: 'download inventory',
  SAVE_ASSET: 'save asset',
  BREAKPOINTS: {
    small: 320,
    medium: 768,
    large: 1025,
  },
  URL_LIST: {
    // bidder registration urls
    MENU_OFFER_REGISTRATION: 'registration/listing/%s/%s/',
    MENU_EVENT_REGISTRATION: 'registration/event/%s/%s/%s/',
  },

  // AssetTransformer
  SELLER_CODE_CW_LIST: [
    'CAN',
    'CWB',
    'CWN',
    'BEC',
    'BEN',
    'CWA',
    'CWC',
    'CWP',
    'CWZ',
  ],
  PROPERTY_TYPE_MAPPING: {
    commercial: {
      1: 'TYPE_PROPERTY_MOTEL',
      2: 'TYPE_PROPERTY_SHOPPING_CENTER',
      3: 'TYPE_PROPERTY_RETAIL',
      4: 'TYPE_PROPERTY_INDUSTRIAL',
      5: 'TYPE_PROPERTY_MULTI_FAMILY',
      6: 'TYPE_PROPERTY_OFFICE',
      7: 'TYPE_PROPERTY_LAND_ONLY',
      8: 'TYPE_PROPERTY_AGRICULTURAL',
      9: 'TYPE_PROPERTY_HOTEL',
      10: 'TYPE_PROPERTY_SENIOR_HOUSING',
      11: 'TYPE_PROPERTY_HEALTHCARE',
      12: 'TYPE_PROPERTY_SPORTS_ENTERTAINMENT',
      13: 'TYPE_PROPERTY_SPECIAL_PURPOSE',
      14: 'TYPE_PROPERTY_MIXED_USE',
      15: 'TYPE_PROPERTY_SELF_STORAGE',
      16: 'TYPE_PROPERTY_PARKING_GARAGE',
      17: 'TYPE_PROPERTY_MEDIAL_OFFICE',
      18: 'TYPE_PROPERTY_INDUSTRIAL_OFFICE',
      19: 'TYPE_AUCTION_RESIDENTIAL',
      20: 'TYPE_PROPERTY_OFFICE_CONDO',
      21: 'TYPE_PROPERTY_INDUSTRIAL_CONDDO',
      22: 'TYPE_PROPERTY_FLEX',
      23: 'TYPE_PROPERTY_CO_OP_FEE_SIMPLE',
      24: 'TYPE_PROPERTY_RD_INDUSTRIAL',
      25: 'TYPE_PROPERTY_LODGING',
      26: 'TYPE_PROPERTY_MOBILE_HOME_PARK',
      31: 'TYPE_PROPERTY_OTHER',
    },
    notes: {
      1: 'TYPE_PROPERTY_CONDO',
      2: 'CATEGORY_4_PLEX',
      3: 'TYPE_PROPERTY_CO_OP',
      4: 'TYPE_PROPERTY_DUPLEX',
      5: 'TYPE_PROPERTY_LAND_ONLY',
      6: 'TYPE_PROPERTY_HOTEL',
      7: 'TYPE_PROPERTY_APARTMENT',
      8: 'TYPE_AUCTION_RESIDENTIAL',
      9: 'TYPE_PROPERTY_SELF_STORAGE',
      10: 'TYPE_PROPERTY_MULTI_FAMILY',
      11: 'TYPE_PROPERTY_PARKING_GARAGE',
      12: 'TYPE_PROPERTY_FLEX',
      13: 'TYPE_PROPERTY_MEDIAL_OFFICE',
      14: 'TYPE_PROPERTY_SPECIAL_PURPOSE',
      15: 'TYPE_PROPERTY_CO_OP_FEE_SIMPLE',
      16: 'TYPE_PROPERTY_MIXED_USE',
      17: 'TYPE_PROPERTY_RETAIL',
      18: 'TYPE_PROPERTY_OFFICE',
      19: 'TYPE_PROPERTY_INDUSTRIAL',
      20: 'TYPE_PROPERTY_OTHER',
      21: 'TYPE_PROPERTY_MOBILE_HOME_PARK',
      22: 'TYPE_PROPERTY_MEZZANINE',
      23: 'TYPE_PROPERTY_RESIDENTIAL',
    },
  },
}

/**
 * [Messages] Page Helmet
 */
const page = {
  PAGE_DESCRIPTION: 'Event Details Page',
  BIDDING_STARTED: 'Bidding Started',
  BIDDING_ENDED: 'Bidding Ended',
}

/**
 * [Messages] Errors
 */
const errors = {
  DEFAULT_ERROR_TITLE: 'Event Details',
  DEFAULT_ERROR_BODY:
    "We're having a technical problem. Please try again in a few minutes.",
}

/**
 * Asset Filters
 */
const assetFilters = {
  FILTERS_TITLE: 'Filter Properties By',
  PROPERTY_TYPE_TITLE: 'Property Type',
  RESET_FILTERS: 'Reset Filters',
  PROPERTY_DETAILS_TITLE: 'Property Details',
  PRICE_TITLE: 'Price',
  BEDS_TITLE: 'Beds',
  BATHS_TITLE: 'Baths',
  SQFT_TITLE: 'Square Feet',
  YEAR_BUILT_TITLE: 'Year Built',
  OCCUPANCY_STATUS_TITLE: 'Occupancy Status',
  DEFAULT_STATE_FILTER: {
    label: 'Select State',
    value: null,
  },
  DEFAULT_COUNTY_FILTER: {
    label: 'Select County',
    value: null,
  },
  DEFAULT_CITY_FILTER: {
    label: 'Select City',
    value: null,
  },

  // THIS IS TO HANDLE DATA TRANSFORM FROM UI TO API
  // (ONLY EXCLUDED PROPERTY TYPE FILTER DUE CUSTOM VALUE EXPECTED)
  API_FILTER_KEYS: {
    minPrice: 'price_min',
    maxPrice: 'price_max',
    beds: 'beds_min',
    baths: 'baths_min',
    sqft: 'sqft_max',
    yearBuiltFrom: 'yr_bt_min',
    yearBuiltTo: 'yr_bt_max',
    occupancyStatus: 'occ_status',
    stateFilter: 'property_state',
    countyFilter: 'property_county',
    cityFilter: 'property_city',
  },
  PROPERTY_TYPE_FILTERS: [
    {
      label: 'Single-Family',
      value: 'single_family',
      usecodePropertyType: 'resi_sfr',
    },
    {
      label: 'Multi-Family',
      value: 'multi_family',
      usecodePropertyType: 'resi_mfr',
    },
    {
      label: 'Condos/Townhouses',
      value: 'condo_townhouse',
      usecodePropertyType: 'resi_condo',
    },
    {
      label: 'Land',
      value: 'land_only',
      usecodePropertyType: 'resi_land',
    },
  ],
  ALL_ASSETS: 'ALL',
  AVAILABLE_ASSETS: 'AVAILABLE',
  POSTPONED_ASSETS: 'POSTPONED',
  CANCELLED_ASSETS: 'REMOVED',
  MIN_PRICE: [
    {
      label: 'min',
      value: null,
    },
    {
      label: '$100k',
      value: '100000',
    },
    {
      label: '$250k',
      value: '250000',
    },
    {
      label: '$500k',
      value: '500000',
    },
    {
      label: '$1M',
      value: '1000000',
    },
    {
      label: '$20M',
      value: '20000000',
    },
  ],
  MAX_PRICE: [
    {
      label: 'max',
      value: null,
    },
    {
      label: '$100k',
      value: '100000',
    },
    {
      label: '$250k',
      value: '250000',
    },
    {
      label: '$500k',
      value: '500000',
    },
    {
      label: '$1M',
      value: '1000000',
    },
    {
      label: '$20M',
      value: '20000000',
    },
  ],
  BEDS: [
    {
      label: 'any',
      value: null,
    },
    {
      label: '1+',
      value: '1',
    },
    {
      label: '2+',
      value: '2',
    },
    {
      label: '3+',
      value: '3',
    },
    {
      label: '4+',
      value: '4',
    },
  ],
  BATHS: [
    {
      label: 'any',
      value: null,
    },
    {
      label: '1+',
      value: '1',
    },
    {
      label: '2+',
      value: '2',
    },
    {
      label: '3+',
      value: '3',
    },
    {
      label: '4+',
      value: '4',
    },
  ],
  SQFT: [
    {
      label: 'any',
      value: null,
    },
    {
      label: '< 500 Sq Ft',
      value: '500',
    },
    {
      label: '< 750 Sq Ft',
      value: '750',
    },
    {
      label: '< 1,000 Sq Ft',
      value: '1000',
    },
    {
      label: '< 1,250 Sq Ft',
      value: '1250',
    },
    {
      label: '< 1,500 Sq Ft',
      value: '1500',
    },
    {
      label: '< 1,750 Sq Ft',
      value: '1750',
    },
    {
      label: '< 2,000 Sq Ft',
      value: '2000',
    },
    {
      label: '< 2,250 Sq Ft',
      value: '2250',
    },
    {
      label: '< 2,500 Sq Ft',
      value: '2500',
    },
    {
      label: '< 2,750 Sq Ft',
      value: '2750',
    },
    {
      label: '< 3,000 Sq Ft',
      value: '3000',
    },
    {
      label: '< 3,500 Sq Ft',
      value: '3500',
    },
    {
      label: '< 4,000 Sq Ft',
      value: '4000',
    },
    {
      label: '< 5,000 Sq Ft',
      value: '5000',
    },
    {
      label: '< 7,500 Sq Ft',
      value: '7500',
    },
  ],
  OCCUPANCY_STATUS: [
    {
      label: 'any',
      value: null,
    },
    {
      label: 'Occupied',
      value: 'occupied',
    },
    {
      label: 'Vacant',
      value: 'vacant',
    },
    {
      label: 'Unknown',
      value: 'unknown',
    },
  ],
}

/**
 * [Messages] AssetTransformer
 */
const assetTransformer = {
  TYPE_PROPERTY_MOTEL: 'Motel',
  TYPE_PROPERTY_SHOPPING_CENTER: 'Shopping Center',
  TYPE_PROPERTY_RETAIL: 'Retail',
  TYPE_PROPERTY_INDUSTRIAL: 'Industrial',
  TYPE_PROPERTY_MULTI_FAMILY: 'Multi-Family',
  TYPE_PROPERTY_OFFICE: 'Office',
  TYPE_PROPERTY_LAND_ONLY: 'Land Only',
  TYPE_PROPERTY_AGRICULTURAL: 'Agricultural',
  TYPE_PROPERTY_HOTEL: 'Hotel',
  TYPE_PROPERTY_SENIOR_HOUSING: 'Senior Housing',
  TYPE_PROPERTY_HEALTHCARE: 'Healthcare',
  TYPE_PROPERTY_SPORTS_ENTERTAINMENT: 'Sports/Entertainment',
  TYPE_PROPERTY_SPECIAL_PURPOSE: 'Special Purpose',
  TYPE_PROPERTY_MIXED_USE: 'Mixed-Use',
  TYPE_PROPERTY_SELF_STORAGE: 'Self-Storage',
  TYPE_PROPERTY_PARKING_GARAGE: 'Parking Garage',
  TYPE_PROPERTY_MEDIAL_OFFICE: 'Medical Office',
  TYPE_PROPERTY_INDUSTRIAL_OFFICE: 'Industrial/Office',
  TYPE_AUCTION_RESIDENTIAL: 'Residential',
  TYPE_PROPERTY_OFFICE_CONDO: 'Office/Condo',
  TYPE_PROPERTY_INDUSTRIAL_CONDDO: 'Industrial/Condo',
  TYPE_PROPERTY_FLEX: 'Flex',
  TYPE_PROPERTY_CO_OP_FEE_SIMPLE: 'CO-OP (Fee Simple)',
  TYPE_PROPERTY_RD_INDUSTRIAL: 'R&D Industrial',
  TYPE_PROPERTY_LODGING: 'Lodging',
  TYPE_PROPERTY_MOBILE_HOME_PARK: 'Mobile Home Park',
  TYPE_PROPERTY_OTHER: 'Other',
  TYPE_PROPERTY_CONDO: 'Condo',
  CATEGORY_4_PLEX: '4-Plex',
  TYPE_PROPERTY_CO_OP: 'Co-op',
  TYPE_PROPERTY_DUPLEX: 'Duplex',
  TYPE_PROPERTY_APARTMENT: 'Apartment',
  TYPE_PROPERTY_MEZZANINE: 'Mezzanine',
  TYPE_PROPERTY_RESIDENTIAL: 'Residential',
  TYPE_PRODUCT_FORECLOSURE_TRUSTEE: 'Foreclosure Sale',
  ACTION_SEARCH_SEE_DUE_DILIGENCE: 'See Due Diligence',
  LABEL_CASE_NO: 'Case No',
  LABEL_FORE_TRUS_NO: 'Foreclosure/Trustee No',
}

/**
 * Asset Sort By && Pagination
 */
const assetNavigation = {
  PAGE_SIZE: [
    {
      value: 12,
      label: '12 per page',
    },
    {
      value: 24,
      label: '24 per page',
    },
    {
      value: 48,
      label: '48 per page',
    },
  ],
  SORT_BY_LIST: [
    {
      value: 'resi_sort_v2',
      label: 'Best Match',
    },
    {
      value: 'auction_date_order',
      label: 'Auction End Time',
    },
    {
      value: 'property_city',
      label: 'City',
    },
    {
      value: 'property_zip',
      label: 'Zip',
    },
    {
      value: 'starting_bid_asc',
      label: 'Starting Bid (Low to High)',
    },
    {
      value: 'starting_bid_desc',
      label: 'Starting Bid (High to Low)',
    },
    {
      value: 'sqft_asc',
      label: 'Square Footage (Low to High)',
    },
    {
      value: 'sqft_desc',
      label: 'Square Footage (High to Low)',
    },
  ],
}

/**
 * Verification Modal Messages
 */
const verificationModal = {
  VERIFICATION_MODAL_SUCCESS_TITLE: 'User Verification Completed',
  VERIFICATION_MODAL_FAIL_TITLE: 'Incorrect password',
  VERIFICATION_MODAL_FAIL_BODY:
    'You have reached the limit number of attempts. Please try again.',
}

/**
 * Auth force login to be used - cookie name
 */
const forceLoginCookieName = {
  FORCE_LOGIN_COOKIE: 'AUTH_SHOW_LOGIN',
}

/**
 * Auth Modal auth_types to switch between login and signup tabs
 */

const authTypes = {
  LOGIN: 'login',
  SIGNUP: 'signup',
}

// Use spread operator to include the values on the exports.
export default {
  ...constants,
  ...page,
  ...errors,
  ...assetFilters,
  ...assetTransformer,
  ...assetNavigation,
  ...verificationModal,
  ...forceLoginCookieName,
  ...authTypes,
}
